import _ from 'lodash'
import * as R from 'ramda'
import { SET_TICKET_SATISFACTION_LEADERBOARD, TRIGGER_LEADERBOARD_SORT_FILTER } from 'actions'

const initialState = {
  sort: {
    key: 'satisfaction_percentage',
    desc: true,
  },
  count: 0,
  leaderboard: [],
}

export default (state = initialState, action) => {
  switch (action.type) {
    case SET_TICKET_SATISFACTION_LEADERBOARD: {
      return R.merge(state, {
        count: action.count,
        leaderboard: action.leaderboard,
      })
    }
    case TRIGGER_LEADERBOARD_SORT_FILTER: {
      const filterKey = action.filterKey
      const descending = action.descending

      return _.merge({}, state, {
        sort: {
          key: filterKey,
          desc: descending,
        },
      })
    }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/reducers/pages/ticketSatisfaction/index.js